export default {
  title: '上传数据',
  menu: '上传数据',
  label: {
    jobId: '工作编号',
    selectFileWithColon: '选择文件',
    downloadResumeTemplate: '下载简历模板',
    sendingNotification: '发送通知',
    emailOrSMS: '邮件或短信',
    selectFile: '选择文件',
    noSelectFile: '未选择任何文件',
    importDataStatus: '导入数据状态',
    importing: '导入中...',
    candidate: '求职者',
    successFinishImport: '导入成功',
    failedImport: '导入失败',
    upload: '上传'
  },
  placeholder: {
  },
  message: {
  }
}
